import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Column } from 'seagull';
import styles from './frame-layout.module.scss';
export const MessageItems = (param)=>{
    let { children, testId, gap, fullWidth = false, padBottom = true } = param;
    return /*#__PURE__*/ _jsx(Column, {
        gap: gap,
        testId: testId,
        className: cn(styles.items, {
            [styles.padBottom]: padBottom,
            [styles.fullWidth]: fullWidth
        }),
        children: children
    });
};
